import { Tag } from "lucide-react";
import { DealsRoutes } from "./routes";
import { DealsPermissions } from "./permissions";
import type { INavItem } from "@/models/INavItem";

export const dealsNav: INavItem = {
  labelKey: "nav.deals",
  icon: Tag,
  path: DealsRoutes.TRAVEL_DEALS_LIST,
  permissions: [DealsPermissions.DEALS_READ],
  permissionPrefix: "Travel:Deals:",
  children: [
    {
      labelKey: "nav.travel_deals",
      path: DealsRoutes.TRAVEL_DEALS_LIST,
      permissions: [DealsPermissions.DEALS_READ],
    },
    {
      labelKey: "nav.combo_offers",
      path: DealsRoutes.COMBO_OFFERS_LIST,
      permissions: [DealsPermissions.DEALS_READ],
    },
  ],
};
